import styled from 'styled-components';
import { MTabGroupAlignment } from './MTabGroup.types';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  &.centered {
    justify-content: center;
    align-items: center;
  }

  &.left {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const TabContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TabsWrapper = styled.div<{ alignment: MTabGroupAlignment }>`
  display: flex;
  flex-direction: row;
  gap: 0;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  justify-content: ${({ alignment }) => (alignment === MTabGroupAlignment.Centered ? 'center' : 'flex-start')};

  @media (max-width: 768px) {
    overflow-x: scroll;
  }
`;
